import React from "react"
import classnames from "classnames"
import { Card, YoutubePlayer, CrossIcon, ButtonIcon } from "AtomicComponents"
import styles from "./CardYoutubePlayer.less"

class CardYoutubePlayer extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      showVideo: false
    }
  }

  _handleOnClick = (event) => {
    this.setState({
      showVideo: true
    })
  }

  _handleClose = () => {
    this.setState({
      showVideo: false
    })
  }

  render() {
    const {
      heading, imageSrc, youtubeId, linkText, description, videoSrc, gtm
    } = this.props

    const videoLink = youtubeId || videoSrc

    return (
      <div className={classnames({
        [styles.CardYoutubePlayer]: true
      })}>
        <Card
          {...this.props}
          linkText={videoLink ? "Watch Video" : linkText}
          onClick={this._handleOnClick}
        />
        {this.state.showVideo && videoLink &&
          <div className={classnames({
            [styles.YoutubeFrameShadow]: true
          })}>
            <div className={classnames({
              [styles.YoutubeFrame]: true
            })}>
              <ButtonIcon
                styleName="SquareWhite"
                onClick={this._handleClose}
              >
                <CrossIcon style={{
                  width: "15px",
                  height: "15px"
                }} />
              </ButtonIcon>
              <div className={classnames({
                [styles.YoutubeFrameIframe]: true
              })}>
                <YoutubePlayer youtubeId={videoLink} />
              </div>
            </div>
          </div>
        }
      </div>
    )
  }
}

export default CardYoutubePlayer



// WEBPACK FOOTER //
// ./src/AtomicContainers/CardYoutubePlayer/CardYoutubePlayer.jsx